import { render, staticRenderFns } from "./RegisterSafePlaceUser.vue?vue&type=template&id=59f447c8&scoped=true&"
import script from "./RegisterSafePlaceUser.vue?vue&type=script&lang=js&"
export * from "./RegisterSafePlaceUser.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSafePlaceUser.vue?vue&type=style&index=0&id=59f447c8&prod&scoped=true&lang=scss&"
import style1 from "./RegisterSafePlaceUser.vue?vue&type=style&index=1&id=59f447c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f447c8",
  null
  
)

export default component.exports